// extracted by mini-css-extract-plugin
export var indeterminate = "_1r-6";
export var md = "_1r-5";
export var semantic = "_1r-7";
export var sm = "_1r-4";
export var text = "_1r-8";
export var toggleControl = "_1r-0";
export var toggleInput = "_1r-1";
export var toggleSwitch = "_1r-2";
export var xs = "_1r-3";